import * as React from "react";
const SvgFiRrQuestionSquare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-question-square_svg__a)">
      <path
        fill="#062147"
        d="M12 16a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 12 16m1-2c0-.561.408-1.225.928-1.512a4.02 4.02 0 0 0 2.009-4.222c-.283-1.614-1.608-2.938-3.221-3.22a4.03 4.03 0 0 0-3.287.873A4 4 0 0 0 8 8.983a1 1 0 0 0 2 0 2 2 0 0 1 2.371-1.968 2.02 2.02 0 0 1 1.596 1.596 2 2 0 0 1-1.004 2.125C11.807 11.373 11 12.715 11 14a1 1 0 1 0 2 0m11 5V5c0-2.757-2.243-5-5-5H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5M19 2c1.654 0 3 1.346 3 3v14c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-question-square_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrQuestionSquare;
